import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class EstadisticasService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/estadisticas/'
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/front-user-dev/src/app/shared/services/api/estadisticas.service.ts